import { render } from "./seat-details.vue?vue&type=template&id=edef7946&scoped=true"
import script from "./seat-details.vue?vue&type=script&lang=js"
export * from "./seat-details.vue?vue&type=script&lang=js"

import "./seat-details.vue?vue&type=style&index=0&id=edef7946&scoped=true&lang=css"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edef7946"]])

export default __exports__